import { certificates, employeeCertificates } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { withAttachments } from './attachment'

// Certificate (master list, managed in configuration view)
export const selectCertificateSchema = createSelectSchema(certificates)
export const insertCertificateSchema = createInsertSchema(certificates).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})
export const updateCertificateSchema = insertCertificateSchema.partial()

// Employee certificate (a certificate held by an employee)
export const selectEmployeeCertificateSchema =
  createSelectSchema(employeeCertificates)
export const insertEmployeeCertificateSchema = createInsertSchema(
  employeeCertificates,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

// Employee certificate with the certificate details + photo attachment
export const selectEmployeeCertificateWithDetailsSchema = withAttachments(
  selectEmployeeCertificateSchema.extend({
    certificate: selectCertificateSchema,
  }),
)

// Type exports
export type Certificate = z.infer<typeof selectCertificateSchema>
export type CreateCertificate = z.infer<typeof insertCertificateSchema>
export type UpdateCertificate = z.infer<typeof updateCertificateSchema>
export type EmployeeCertificate = z.infer<
  typeof selectEmployeeCertificateSchema
>
export type CreateEmployeeCertificate = z.infer<
  typeof insertEmployeeCertificateSchema
>
export type EmployeeCertificateWithDetails = z.infer<
  typeof selectEmployeeCertificateWithDetailsSchema
>
